export function throwNull<T>(value: T | null | undefined, message: string): T {
    if (value === null || value === undefined) {
        throw new Error(message)
    } else {
        return value
    }
}
